<template>
  <div class="ui small modal" ref="modal">
    <div class="ui inverted dimmer">
      <div class="ui text double slow blue loader">{{ $t("loading") }}</div>
    </div>
    <i class="close icon"></i>
    <div class="icon header">
      <i class="key icon"></i>
      {{ $t("password change") }}
    </div>
    <div class="image scrolling content">
      <div class="ui small image">
        <img src="/images/icons/password.png" style="width: 100% !important" />
      </div>
      <div class="description" style="width: 100% !important">
        <h4 class="ui dividing header">{{ $t("confirm password change") }}</h4>

        <div class="ui form" ref="form">
          <div class="two fields">
            <div class="field">
              <label for>{{ $t("current password") }}</label>
              <input
                type="password"
                name="current"
                v-model="current_password"
              />
            </div>
            <div class="field">
              <label for>{{ $t("new password") }}</label>
              <input type="password" name="new" v-model="new_password" />
            </div>
          </div>
          <div class="ui error message"></div>
        </div>
      </div>
    </div>
    <div class="actions">
      <div class="ui green icon right labeled button" @click="save">
        <i class="check icon"></i>
        {{ $t("ok") }}
      </div>
      <div class="ui blue icon right labeled negative button">
        <i class="close icon"></i>
        {{ $t("close") }}
      </div>
    </div>
  </div>
</template>

<script>
import { local_api, success_toast, error_toast } from "@/utils";
// import GenericModal from "@/components/GenericModal";
import sha1 from "js-sha1";

export default {
  name: "ChangePasswordModal",
  components: {
    // "generic-modal": GenericModal,
  },
  // props: {
  //   user_in: Object,
  // },
  data() {
    return {
      user_in: {},
      current_password: "",
      new_password: "",
    };
  },
  methods: {
    save() {
      let vm = this;
      let isValid = window.jQuery(vm.$refs.form).form("validate form");

      if (isValid) {
        local_api(vm, "post", "/user/do-change-password", {
          c: sha1(vm.current_password),
          n: sha1(vm.new_password),
          u: vm.user_in.encrypted_id,
        })
          .then(() => {
            success_toast(vm.$t("password updated"));
            window.jQuery(vm.$refs.modal).modal("hide");
          })
          .catch((err) => {
            error_toast(err);
          });
      }
    },
    show_modal(user_in) {
      let vm = this;
      vm.user_in = user_in;
      window.jQuery(vm.$refs.form).form({
        fields: {
          current: ["empty"],
          new: ["empty"],
        },
      });

      window
        .jQuery(vm.$refs.modal)
        .modal({
          onHide() {
            window.jQuery(vm.$refs.form).form("reset");
          },
        })
        .modal("show");
    },
  },
  mounted() {
    // let vm = this;
    // window.jQuery(vm.$refs.form).form({
    //   fields: {
    //     current: ["empty"],
    //     new: ["empty"],
    //   },
    // });
  },
  created() {},
  watch: {},
  updated: function () {},
};
</script>
